import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getFilters = (state) => get(state, 'roles.filters', {});
export const getPagination = (state) => get(state, 'roles.pagination', {});
export const getIsLoading = (state) => get(state, 'roles.isLoading', false);
export const getNeedFetch = (state) => get(state, 'roles.needFetch', false);

export const getRoles = (state) => get(state, 'roles.entities.roles', {});
export const getRolesIds = (state) => get(state, 'roles.result.roles', []);
export const getEditingRole = (state) => get(state, 'roles.editing', []);

export const getVisibleRoles = createSelector([getRolesIds, getRoles], (ids, roles) =>
  ids.map((id) => roles[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/selectors/roles_selectors.js